interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-archive-line',
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-lg border border-dashed border-background-300 bg-background-50">
      <span className="w-14 h-14 rounded-full bg-background-100 flex items-center justify-center text-foreground-400 mb-4">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <h3 className="text-base font-semibold text-foreground-900">{title}</h3>
      {description && <p className="text-sm text-foreground-500 mt-2 max-w-sm">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2 rounded-md text-sm bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}